import PropTypes from 'prop-types';
import React from 'react';
import RouterContext from './RouterContext';

// create typings and import from react-router
import { jsx as _jsx } from "react/jsx-runtime";
const ContextWrapper = (props, context) => {
  const {
    history,
    route: {
      location,
      match
    } = {}
  } = context.router;
  return /*#__PURE__*/_jsx(RouterContext.Provider, {
    value: {
      location,
      history,
      match
    },
    children: props.children
  });
};

// This is required for Legacy Context to work
// https://reactjs.org/docs/legacy-context.html#how-to-use-context
ContextWrapper.contextTypes = {
  router: PropTypes.shape({
    history: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  })
};
export default ContextWrapper;